/**
 * Russian translations for the CRM UI.
 * Merged on top of the English catalog, so any missing key falls back to English.
 */
export const russianCrmMessages = {
  resources: {
    companies: {
      name: "Компания |||| Компании",
      forcedCaseName: "Компания",
      fields: {
        name: "Название компании",
        website: "Сайт",
        linkedin_url: "LinkedIn",
        phone_number: "Телефон",
        created_at: "Создана",
        nb_contacts: "Число контактов",
        revenue: "Выручка",
        sector: "Отрасль",
        size: "Размер",
        tax_identifier: "ИНН",
        address: "Адрес",
        city: "Город",
        zipcode: "Индекс",
        state_abbr: "Регион",
        country: "Страна",
        description: "Описание",
        context_links: "Ссылки",
        sales_id: "Ответственный",
      },
      empty: {
        description: "Список компаний пока пуст.",
        title: "Компании не найдены",
      },
      field_categories: {
        contact: "Контакты",
        additional_info: "Дополнительно",
        address: "Адрес",
        context: "Контекст",
      },
      action: {
        create: "Создать компанию",
        edit: "Редактировать компанию",
        new: "Новая компания",
        show: "Открыть компанию",
      },
      added_on: "Добавлена %{date}",
      followed_by: "Ведёт %{name}",
      followed_by_you: "Ведёте вы",
      no_contacts: "Нет контактов",
      nb_contacts:
        "%{smart_count} контакт |||| %{smart_count} контакта |||| %{smart_count} контактов",
      nb_deals:
        "%{smart_count} сделка |||| %{smart_count} сделки |||| %{smart_count} сделок",
      sizes: {
        one_employee: "1 сотрудник",
        two_to_nine_employees: "2–9 сотрудников",
        ten_to_forty_nine_employees: "10–49 сотрудников",
        fifty_to_two_hundred_forty_nine_employees: "50–249 сотрудников",
        two_hundred_fifty_or_more_employees: "250 и более сотрудников",
      },
      autocomplete: {
        create_error: "Не удалось создать компанию",
        create_item: "Создать «%{item}»",
        create_label: "Начните вводить, чтобы создать новую компанию",
      },
      filters: {
        only_mine: "Только мои",
      },
    },
    contacts: {
      name: "Клиент |||| Клиенты",
      forcedCaseName: "Клиент",
      field_categories: {
        background_info: "Досье",
        identity: "Имя",
        misc: "Прочее",
        personal_info: "Контактные данные",
        position: "Должность",
      },
      fields: {
        first_name: "Имя",
        last_name: "Фамилия",
        last_seen: "Последняя активность",
        title: "Должность",
        company_id: "Компания",
        email_jsonb: "Email-адреса",
        email: "Email",
        phone_jsonb: "Телефоны",
        phone_number: "Телефон",
        linkedin_url: "LinkedIn",
        background: "Заметки о клиенте (кто такой, откуда пришёл и т.п.)",
        has_newsletter: "Подписан на рассылку",
        sales_id: "Ответственный",
      },
      action: {
        add: "Добавить клиента",
        add_first: "Добавьте первого клиента",
        create: "Создать клиента",
        edit: "Редактировать клиента",
        export_vcard: "Экспорт в vCard",
        new: "Новый клиент",
        show: "Открыть клиента",
      },
      background: {
        last_activity_on: "Последняя активность %{date}",
        added_on: "Добавлен %{date}",
        followed_by: "Ведёт %{name}",
        followed_by_you: "Ведёте вы",
        status_none: "Без статуса",
      },
      position_at: "%{title} в",
      position_at_company: "%{title} в %{company}",
      empty: {
        description: "Список клиентов пока пуст.",
        title: "Клиенты не найдены",
      },
      import: {
        title: "Импорт клиентов",
        button: "Импорт CSV",
        complete:
          "Импорт завершён. Импортировано клиентов: %{importCount}, ошибок: %{errorCount}",
        progress:
          "Импортировано %{importCount} / %{rowCount}, ошибок: %{errorCount}.",
        error:
          "Не удалось импортировать файл. Проверьте, что это корректный CSV.",
        imported: "Импортировано",
        remaining_time: "Осталось примерно:",
        running: "Идёт импорт, не закрывайте эту вкладку.",
        sample_download: "Скачать пример CSV",
        sample_hint: "Пример CSV-файла, который можно использовать как шаблон",
        stop: "Остановить импорт",
        csv_file: "CSV-файл",
        contacts_label: "клиент |||| клиента |||| клиентов",
      },
      inputs: {
        genders: {
          male: "Мужчина",
          female: "Женщина",
          nonbinary: "Не указано",
        },
        personal_info_types: {
          work: "Рабочий",
          home: "Домашний",
          other: "Другой",
        },
      },
      list: {
        error_loading: "Ошибка загрузки клиентов",
      },
      bulk_tag: {
        action: "Тег",
        back: "Назад к тегам",
        create_description:
          "Создать новый тег и применить к выбранным клиентам.",
        description: "Выберите существующий тег или создайте новый.",
        empty: "Тегов пока нет. Создайте первый.",
        error: "Не удалось добавить тег",
        noop: "У выбранных клиентов уже есть этот тег",
        success:
          "Тег добавлен %{smart_count} клиенту |||| Тег добавлен %{smart_count} клиентам |||| Тег добавлен %{smart_count} клиентам",
        title: "Добавить тег клиентам",
      },
      merge: {
        action: "Объединить с другим клиентом",
        confirm: "Объединить клиентов",
        current_contact: "Текущий клиент (будет удалён)",
        description: "Объединить этого клиента с другим.",
        error: "Не удалось объединить клиентов",
        merging: "Объединение...",
        no_additional_data: "Нет дополнительных данных для переноса",
        select_target: "Выберите клиента для объединения",
        success: "Клиенты объединены",
        target_contact: "Целевой клиент (останется)",
        title: "Объединение клиентов",
        warning_description:
          "Все данные будут перенесены во второго клиента. Действие необратимо.",
        warning_title: "Внимание: необратимая операция",
        what_will_be_merged: "Что будет объединено:",
      },
      filters: {
        before_last_month: "Раньше прошлого месяца",
        before_this_month: "Раньше этого месяца",
        before_this_week: "Раньше этой недели",
        managed_by_me: "Мои клиенты",
        search: "Поиск по имени, телефону...",
        this_week: "На этой неделе",
        today: "Сегодня",
        tags: "Теги",
        tasks: "Задачи",
      },
      hot: {
        empty_change_status:
          "Статус клиента меняется в заметке: добавьте заметку и нажмите «Показать параметры».",
        empty_hint: "Здесь появятся клиенты со статусом «Горячий».",
        title: "Горячие клиенты",
      },
    },
    deals: {
      name: "Сделка |||| Сделки",
      fields: {
        name: "Название",
        description: "Комментарий",
        company_id: "Компания",
        contact_ids: "Клиент",
        category: "Категория",
        amount: "Сумма",
        expected_closing_date: "Ожидаемая дата закрытия",
        stage: "Стадия",
        created_at: "Создана",
        coverage: "Покрытие",
        dobory: "Доборы",
        hinges: "Петли",
        address: "Адрес",
        parking: "Парковка",
        master_id: "Мастер",
      },
      action: {
        back_to_deal: "Назад к сделке",
        create: "Создать сделку",
        new: "Новая сделка",
      },
      field_categories: {
        misc: "Параметры",
        order: "Заказ",
        object: "Объект",
      },
      archived: {
        action: "В архив",
        error: "Ошибка: сделка не заархивирована",
        list_title: "Архив сделок",
        success: "Сделка в архиве",
        title: "Архивная сделка",
        view: "Архив сделок",
      },
      inputs: {
        linked_to: "Связи",
      },
      unarchived: {
        action: "Вернуть на доску",
        error: "Ошибка: сделка не восстановлена",
        success: "Сделка возвращена",
      },
      updated: "Сделка обновлена",
      empty: {
        before_create: "прежде чем создавать сделку.",
        description: "Список сделок пока пуст.",
        title: "Сделки не найдены",
      },
      invalid_date: "Неверная дата",
    },
    masters: {
      name: "Мастер |||| Мастера",
      forcedCaseName: "Мастер",
      fields: {
        name: "Имя мастера",
        phone: "Телефон",
        status: "Статус",
        rating: "Рейтинг",
        specialization: "Специализация",
        districts: "Районы",
        comment: "Комментарий",
        sales_id: "Ответственный",
        created_at: "Добавлен",
        nb_deals: "Сделок",
      },
      action: {
        create: "Добавить мастера",
        edit: "Редактировать мастера",
        new: "Новый мастер",
        show: "Открыть мастера",
      },
      empty: {
        description: "Список мастеров пока пуст.",
        title: "Мастера не найдены",
      },
      nb_deals:
        "%{smart_count} сделка |||| %{smart_count} сделки |||| %{smart_count} сделок",
      updated: "Карточка мастера обновлена",
    },
    notes: {
      name: "Заметка |||| Заметки",
      forcedCaseName: "Заметка",
      fields: {
        status: "Статус",
        date: "Дата",
        attachments: "Вложения",
        contact_id: "Клиент",
        deal_id: "Сделка",
      },
      action: {
        add: "Добавить заметку",
        add_first: "Добавьте первую заметку",
        delete: "Удалить заметку",
        edit: "Редактировать",
        update: "Сохранить заметку",
        add_this: "Добавить заметку",
      },
      sheet: {
        create: "Новая заметка",
        create_for: "Заметка для %{name}",
        edit: "Редактирование заметки",
        edit_for: "Заметка для %{name}",
      },
      deleted: "Заметка удалена",
      empty: "Заметок пока нет",
      author_added: "%{name} — заметка",
      you_added: "Вы добавили заметку",
      me: "Я",
      list: {
        error_loading: "Ошибка загрузки заметок",
      },
      note_for_contact: "Заметка для %{name}",
      stepper: {
        hint: "Откройте карточку клиента и добавьте заметку",
      },
      added: "Заметка добавлена",
      inputs: {
        add_note: "Добавить заметку",
        options_hint: "(файлы и параметры)",
        show_options: "Показать параметры",
      },
      actions: {
        attach_document: "Прикрепить файл",
      },
      validation: {
        note_or_attachment_required: "Нужен текст заметки или вложение",
      },
    },
    sales: {
      name: "Пользователь |||| Пользователи",
      fields: {
        first_name: "Имя",
        last_name: "Фамилия",
        email: "Email",
        administrator: "Администратор",
        disabled: "Отключён",
      },
      create: {
        error: "Не удалось создать пользователя.",
        success: "Пользователь создан. Ему придёт письмо для установки пароля.",
        title: "Новый пользователь",
      },
      edit: {
        error: "Произошла ошибка. Попробуйте ещё раз.",
        record_not_found: "Запись не найдена",
        success: "Пользователь обновлён",
        title: "Редактирование: %{name}",
      },
      action: {
        new: "Новый пользователь",
      },
    },
    tasks: {
      name: "Задача |||| Задачи",
      forcedCaseName: "Задача",
      fields: {
        text: "Описание",
        due_date: "Срок",
        type: "Тип",
        contact_id: "Клиент",
        due_short: "срок",
      },
      action: {
        add: "Добавить задачу",
        create: "Создать задачу",
        edit: "Редактировать задачу",
      },
      actions: {
        postpone_next_week: "Перенести на следующую неделю",
        postpone_tomorrow: "Перенести на завтра",
        title: "действия с задачей",
      },
      added: "Задача добавлена",
      deleted: "Задача удалена",
      dialog: {
        create: "Новая задача",
        create_for: "Задача для %{name}",
      },
      sheet: {
        edit: "Редактирование задачи",
        edit_for: "Задача для %{name}",
      },
      empty: "Задач пока нет",
      empty_list_hint: "Здесь появятся задачи по вашим клиентам.",
      filters: {
        later: "Позже",
        overdue: "Просроченные",
        this_week: "На этой неделе",
        today: "Сегодня",
        tomorrow: "Завтра",
        with_pending: "С активными задачами",
      },
      regarding_contact: "(по: %{name})",
      updated: "Задача обновлена",
    },
    tags: {
      name: "Тег |||| Теги",
      action: {
        add: "Добавить тег",
        create: "Создать тег",
      },
      dialog: {
        color: "Цвет",
        create_title: "Новый тег",
        edit_title: "Редактирование тега",
        name_label: "Название тега",
        name_placeholder: "Введите название",
      },
    },
  },
  crm: {
    action: {
      reset_password: "Сбросить пароль",
    },
    auth: {
      first_name: "Имя",
      last_name: "Фамилия",
      confirm_password: "Подтвердите пароль",
      confirmation_required:
        "Перейдите по ссылке из письма, чтобы подтвердить аккаунт.",
      recovery_email_sent:
        "Если вы зарегистрированы, письмо для восстановления пароля скоро придёт.",
      sign_in_failed: "Не удалось войти.",
      sign_in_google_workspace: "Войти через Google Workspace",
      signup: {
        create_account: "Создать аккаунт",
        create_first_user:
          "Создайте первого пользователя, чтобы завершить настройку.",
        creating: "Создание...",
        initial_user_created: "Первый пользователь создан",
      },
      welcome_title: "Добро пожаловать в CRM",
    },
    common: {
      activity: "Активность",
      added: "добавлено",
      details: "Детали",
      last_activity_with_date: "активность %{date}",
      load_more: "Показать ещё",
      misc: "Прочее",
      past: "Прошедшие",
      read_more: "Читать далее",
      retry: "Повторить",
      show_less: "Свернуть",
      copied: "Скопировано!",
      copy: "Копировать",
      loading: "Загрузка...",
      me: "Я",
      task_count:
        "%{smart_count} задача |||| %{smart_count} задачи |||| %{smart_count} задач",
    },
    changelog: {
      title: "История изменений",
    },
    activity: {
      added_company: "%{name} — новая компания",
      you_added_company: "Вы добавили компанию",
      added_contact: "%{name} — новый клиент:",
      you_added_contact: "Вы добавили клиента:",
      added_note: "%{name} — заметка о",
      you_added_note: "Вы добавили заметку о",
      added_note_about_deal: "%{name} — заметка к сделке",
      you_added_note_about_deal: "Вы добавили заметку к сделке",
      added_deal: "%{name} — новая сделка",
      you_added_deal: "Вы добавили сделку",
      at_company: "в",
      to: "для",
      load_more: "Показать ещё",
    },
    dashboard: {
      deals_chart: "Ожидаемая выручка по сделкам",
      deals_pipeline: "Воронка сделок",
      latest_activity: "Последняя активность",
      latest_activity_error: "Ошибка загрузки активности",
      latest_notes: "Мои последние заметки",
      latest_notes_added_ago: "добавлено %{timeAgo}",
      stepper: {
        install: "Установить CRM",
        progress: "%{step}/3 готово",
        whats_next: "Что дальше?",
      },
      upcoming_tasks: "Ближайшие задачи",
    },
    header: {
      import_data: "Импорт данных",
    },
    image_editor: {
      change: "Изменить",
      drop_hint: "Перетащите файл или кликните для выбора.",
      editable_content: "Редактируемое содержимое",
      title: "Загрузка и обрезка изображения",
      update_image: "Обновить изображение",
    },
    import: {
      action: {
        download_error_report: "Скачать отчёт об ошибках",
        import: "Импортировать",
        import_another: "Импортировать другой файл",
      },
      error: {
        unable: "Не удалось импортировать файл.",
      },
      idle: {
        description_1:
          "Можно импортировать пользователей, компании, клиентов, заметки и задачи.",
        description_2: "Данные должны быть в JSON-файле по следующему образцу:",
      },
      status: {
        all_success: "Все записи импортированы успешно.",
        complete: "Импорт завершён.",
        failed: "С ошибкой",
        imported: "Импортировано",
        in_progress: "Идёт импорт, не уходите с этой страницы.",
        some_failed: "Часть записей не импортирована.",
        table_caption: "Статус импорта",
      },
      title: "Импорт данных",
    },
    settings: {
      about: "О системе",
      companies: {
        sectors: "Отрасли",
      },
      dark_mode_logo: "Логотип (тёмная тема)",
      deals: {
        categories: "Категории",
        currency: "Валюта",
        pipeline_help: "Отметьте стадии, которые считаются активной воронкой.",
        pipeline_statuses: "Стадии воронки",
        stages: "Стадии",
      },
      light_mode_logo: "Логотип (светлая тема)",
      notes: {
        statuses: "Статусы",
      },
      reset_defaults: "Сбросить к значениям по умолчанию",
      save_error: "Не удалось сохранить настройки",
      saved: "Настройки сохранены",
      saving: "Сохранение...",
      tasks: {
        types: "Типы",
      },
      preferences: "Предпочтения",
      title: "Настройки",
      app_title: "Название системы",
      sections: {
        branding: "Оформление",
      },
      validation: {
        duplicate: "Дубликат (%{display_name}): %{items}",
        in_use:
          "Нельзя удалить %{display_name}, которые используются в сделках: %{items}",
        validating: "Проверка…",
        entities: {
          categories: "категории",
          stages: "стадии",
        },
      },
    },
    theme: {
      dark: "Тёмная",
      label: "Тема",
      light: "Светлая",
      system: "Как в системе",
    },
    language: "Язык",
    navigation: {
      label: "Навигация CRM",
    },
    profile: {
      inbound: {
        description:
          "Отправляйте письма на входящий адрес сервера (например, добавив его в поле %{field}) — CRM обработает их и добавит заметки нужным клиентам.",
        title: "Входящая почта",
      },
      mcp: {
        title: "MCP-сервер",
        description:
          "Используйте этот URL, чтобы подключить AI-ассистента к данным CRM по протоколу MCP.",
      },
      password: {
        change: "Сменить пароль",
      },
      password_reset_sent: "Письмо для сброса пароля отправлено на ваш email",
      record_not_found: "Запись не найдена",
      title: "Профиль",
      updated: "Профиль обновлён",
      update_error: "Произошла ошибка. Попробуйте ещё раз",
    },
    validation: {
      invalid_url: "Введите корректный URL",
      invalid_linkedin_url: "URL должен быть с linkedin.com",
    },
  },
};
